import { useAction } from "@/hooks/shared";
import { listInvitationsHandler } from "@/services";

export const useListInvitations = () => useAction(listInvitationsHandler);
